import React, { useState, useEffect } from "react";
import {
  Empty, Divider, Spin, DatePicker,
} from "antd";
import { toast } from "react-toastify";
import Scrollbar from "react-scrollbars-custom";
import dayjs from "dayjs";
import { ArrowRightOutlined } from "@ant-design/icons";
import { getInstruments } from "../../../../../actions/chemistry";

const PlatemapInstrument = ({
  handleSelectInstrument,
  view,
  historyDate,
  setHistoryDate,
}) => {
  const [loading, setLoading] = useState(true);
  const [instruments, setInstruments] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const fetchInstruments = async () => {
    const { success, result, message } = await getInstruments();
    if (success) {
      setInstruments(result);
    } else {
      setInstruments([]);
      toast.error(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchInstruments();
  }, []);

  const handleInstrumentOnclick = (item) => {
    handleSelectInstrument(item);
    if (selectedId && item.id === selectedId) {
      setSelectedId(null);
    } else {
      setSelectedId(item.id);
    }
  };

  return (
    <div className="PlatemapSection">
      <div className="PlatemapSection__Header">
        <div className="PlatemapSection__HeaderContent">
          <h5>Instruments</h5>
          {view === "History" && (
          <DatePicker
            allowClear={false}
            format="MM/DD/YYYY"
            className="Platemap__HistoryDate"
            disabled={!instruments}
            value={dayjs(historyDate)}
            onChange={setHistoryDate}
          />
          )}
        </div>
        <Divider className="PlatemapDivider" />
      </div>
      <Spin wrapperClassName="Platemap__Spin" spinning={loading} size="large">
        {instruments.length > 0 && (
          <Scrollbar
            className="PlatemapItemScrollBar"
            disableTrackYWidthCompensation
            disableTracksWidthCompensation
          >
            <div className="PlatemapSection__Items__Container">
              {instruments.map((item, index) => (
                <span key={index} className={`PlatemapSection__Item${item.id === selectedId ? "--selected" : ""}`} onClick={() => handleInstrumentOnclick(item)}>
                  {item.instrument_name}
                  <ArrowRightOutlined />
                </span>
              ))}
            </div>
          </Scrollbar>
        )}
        {instruments.length === 0 && (<Empty className="PlatemapEmpty" image={Empty.PRESENTED_IMAGE_SIMPLE} />)}
      </Spin>
    </div>
  );
};

export default PlatemapInstrument;
